<template>
    <vx-modal :visible="visible" @update:visible="visible = false" class="max-w-lg" :padding="false">
        <div class="flex flex-col text-center gap-3 py-24 px-12">
            <font-awesome-icon widthAuto :class="color" size="xl" :icon="faTriangleExclamation"></font-awesome-icon>
            <span class="text-3xl font-extrabold text-black leading-9">{{ props.title }}</span>
            <span v-if="props.message" class="text-base font-normal text-black">{{ props.message }}</span>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button v-if="cancelBtn"
                    @click.prevent="visible = false"
                    type="button"
                    class="grow lg:w-20 lg:grow-0"
                    size="lg"
                    color="muted">
                    {{ cancelText }}
                </vx-button>
                <vx-button @click.prevent="emit('confirm')"
                    data-test="confirm-button"
                    type="button"
                    class="grow"
                    size="lg"
                    color="primary">
                    {{ props.confirmText }}
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxButton, VxModal } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { computed } from 'vue';

const emit = defineEmits(['confirm']);

const visible = defineModel('visible', {
    type: Boolean,
    default: false,
});

const props = defineProps({
    confirmText: {
        type: String,
        default: 'Confirm'
    },
    cancelText: {
        type: String,
        default: 'Cancel'
    },
    cancelBtn: {
        type: Boolean,
        default: true
    },
    message: {
        type: String,
    },
    title: {
        type: String,
        default: 'Are you sure?'
    },
    type: {
        type: String,
    }
});

const color = computed(() => props.type === 'danger' ? 'text-rose-500' : 'text-amber-400');
</script>
